import { useEffect, useState } from "react";
import Link from "next/link";
import PropTypes from "prop-types";
import { FaFacebookF, FaInstagram, FaTiktok, FaTwitter } from "react-icons/fa";
import { TfiYoutube } from "react-icons/tfi";
import styles from "./index.module.scss";

const NavItems = ({
  navItem,
  classNames,
  linkClass,
  secondaryNavItemFunc,
  handleCloseHandle,
  navItemLabel = "",
}) => {
  const [cookieClass, setCookieClass] = useState("");

  useEffect(() => {
    if (navItem?.fields?.label.trim() === "Cookies Settings") {
      setCookieClass("ot-sdk-show-settings");
    }
  }, []);

  const getIcon = (label = "") => {
    const lower = label.toLowerCase();

    if (lower.includes("facebook"))
      return (
        <FaFacebookF className="text-[#232323] pl-[5px] h-[22px] w-[22px]" />
      );
    if (lower.includes("instagram"))
      return <FaInstagram className="text-[#232323]" />;
    if (lower.includes("twitter"))
      return (
        <FaTwitter className="text-[#232323] pl-[5px] h-[22px] w-[22px]" />
      );
    if (lower.includes("tiktok"))
      return <FaTiktok className="text-[#232323]" />;

    if (lower.includes("youtube"))
      return <TfiYoutube className="text-[#232323]" />;

    return null;
  };

  const label = navItem?.fields?.label || "";
  const icon = getIcon(label);

  return (
    <div
      key={navItem?.sys?.id}
      className={classNames}
      onClick={e => secondaryNavItemFunc(e, navItem)}
    >
      {navItem?.fields?.url ? (
        <Link
          key={navItem?.fields?.sys?.id}
          target={navItem?.fields?.openerType === "New Tab" ? "_blank" : ""}
          id={
            navItem?.fields?.label.trim() === "Cookies Settings"
              ? "ot-sdk-link"
              : ""
          }
          href={navItem?.fields?.url || ""}
          className={`${cookieClass} flex`}
          style={{ textDecoration: "none", width: "100%" }}
          rel="noreferrer"
          onClick={handleCloseHandle}
        >
          {icon && (
            <div
              className={`${styles.iconWrapper} w-[30px] mr-[10px] h-[30px] bg-[#999] rounded-md flex items-center justify-center`}
            >
              {icon}
            </div>
          )}
          <div className={linkClass}>
            {navItem?.fields?.label ? (
              <span>{navItem?.fields?.label}</span>
            ) : null}
          </div>
        </Link>
      ) : (
        <button
          key={navItem?.fields?.sys?.id}
          type="button"
          id={
            navItem?.fields?.label.trim() === "Cookies Settings"
              ? "ot-sdk-link"
              : ""
          }
          className={`${cookieClass} flex`}
          style={{
            textDecoration: "none",
            width: "100%",
            border: "none",
            background: "none",
            cursor: "pointer",
          }}
          onClick={handleCloseHandle}
          onKeyDown={e => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              handleCloseHandle(e);
            }
          }}
        >
          {icon && (
            <div
              className={`${styles.iconWrapper} w-[30px] mr-[10px] h-[30px] bg-[#999] rounded-md flex items-center justify-center`}
            >
              {icon}
            </div>
          )}
          <div className={linkClass}>
            {navItem?.fields?.label || navItemLabel ? (
              <span>{navItem?.fields?.label || navItemLabel}</span>
            ) : null}
          </div>
        </button>
      )}
    </div>
  );
};
export default NavItems;

NavItems.propTypes = {
  navItem: PropTypes.object,
  secondaryNavItemFunc: PropTypes.func,
  linkClass: PropTypes.string,
  classNames: PropTypes.string,
  handleCloseHandle: PropTypes.func,
};

NavItems.defaultProps = {
  secondaryNavItemFunc: () => {},
  handleCloseHandle: () => {},
  navItem: {},
  classNames: "",
  linkClass: "",
};
